module.exports = __webpack_public_path__ + "img/20230726161929618q2i.c8a17593.jpg";